// src/pages/JewelleryPlans/jewelleryPlanRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";

// Dashboard
import PlansDashboard from "./Dashboard/PlansDashboard";

// Plan Management
import CreatePlanWizard from "./Plans/CreatePlan/CreatePlanWizard";
import ActivePlans from "./Plans/PlansList/ActivePlans";
import MaturedPlans from "./Plans/PlansList/MaturedPlans";
import PlanDetailsPage from "./Plans/PlanDetails/PlanDetailsPage";

// Payment Components
import PaymentsList from "./Payments/PaymentsList";
import PendingVerifications from "./Payments/VerifyPayments/PendingVerifications";
import PaymentForm from "./Payments/RecordPayment/PaymentForm";
import PaymentDetails from "./Payments/PaymentDetails";

// Redemption Components
import RedemptionList from "./Redemptions/RedemptionList";
import RedemptionDetails from "./Redemptions/RedemptionDetails";

// Quote Components
import BalanceCheck from "./Redemptions/BalanceCheck";
import PlanQuotes from "./Redemptions/PlanQuotes";
import QuoteDetails from "./Redemptions/QuoteDetails";

// Admin & Settings
import JewelleryTemplateManager from "./Admin/Templates/TemplateManager";

// Reports
import ReportsHub from "./Reports/ReportsHub";
import PendingVerificationsReport from "./Reports/PendingVerifications";
import OverdueReport from "./Reports/OverdueReport";
import MaturityReport from "./Reports/MaturityReport";
import RedemptionAnalytics from "./Reports/RedemptionAnalytics";

// Cancellation Routes
import CancellationRoutes from "./Cancellation/CancellationRoutes";
import PendingPauseRequestsPage from "./Plans/PendingPauseRequests/PendingPauseRequestsPage";

/**
 * Jewellery Plan Routes
 * All routes related to jewellery plans, payments, redemptions, and cancellations
 */
const JewelleryPlanRoutes = () => {
  return (
    <Routes>
      {/* ==================== DASHBOARD ==================== */}
      <Route path="/" element={<PlansDashboard />} />
      <Route path="/dashboard" element={<PlansDashboard />} />

      {/* ==================== PLAN MANAGEMENT ==================== */}
      <Route path="/new" element={<CreatePlanWizard />} />
      <Route path="/active" element={<ActivePlans />} />
      <Route path="/matured" element={<MaturedPlans />} />
      <Route path="/:planId" element={<PlanDetailsPage />} />
      <Route path="/pause/pending" element={<PendingPauseRequestsPage />} />

      {/* ==================== PAYMENTS ==================== */}
      <Route path="/payments" element={<PaymentsList />} />
      <Route path="/payments/verify" element={<PendingVerifications />} />
      <Route path="/payments/record/:planId" element={<PaymentForm />} />
      <Route path="/payments/:paymentId" element={<PaymentDetails />} />
      <Route path="/:planId/payment" element={<PaymentForm />} />

      {/* ==================== REDEMPTIONS ==================== */}
      <Route path="/redemptions" element={<RedemptionList />} />
      <Route
        path="/redemptions/:redemptionId"
        element={<RedemptionDetails />}
      />
      <Route path="/:planId/redeem" element={<RedemptionDetails />} />

      {/* ==================== QUOTE ROUTES ==================== */}
      <Route path="/redemptions/quote" element={<BalanceCheck />} />
      <Route path="/:planId/quote" element={<BalanceCheck />} />
      <Route path="/:planId/create-quote" element={<BalanceCheck />} />
      <Route path="/:planId/quotes" element={<PlanQuotes />} />
      <Route path="/:planId/quote/:quoteId" element={<QuoteDetails />} />

      {/* ==================== ADMIN & SETTINGS ==================== */}
      <Route path="/templates" element={<JewelleryTemplateManager />} />

      {/* ==================== REPORTS ==================== */}
      <Route path="/reports" element={<ReportsHub />} />
      <Route
        path="/reports/pending-verifications"
        element={<PendingVerificationsReport />}
      />
      <Route path="/reports/overdues" element={<OverdueReport />} />
      <Route path="/reports/maturities" element={<MaturityReport />} />
      <Route path="/reports/redemptions" element={<RedemptionAnalytics />} />

      {/* ==================== CANCELLATIONS (NESTED) ==================== */}
      <Route path="/cancellations/*" element={<CancellationRoutes />} />
    </Routes>
  );
};

export default JewelleryPlanRoutes;
